<template>
  <div>
    <div>
      <div class="c-card-body">
        <datatable
          ref="datatable"
          module="merchandise"
          :title="title"
          :filter="filter"
          :url="url"
          :columns="columns"
          :on-click-create="onClickCreate"
          :on-click-update="onClickUpdate"
          :on-click-delete="onClickDelete"
          :on-click-export="onClickExport"
          :action-width="180"
        >
      <template v-slot:action>
            <v-col md="3">
              <v-select
                label="Merchandise"
                required
                dense
                outlined
                v-model="filterMerchandise"
                :items="listMerchandise"
                item-text="name"
                item-value="id"
                hide-details="true"
                clearable
              ></v-select>
            </v-col>
            <v-col md="3">
              <date-picker
                placeholder="Tanggal Restock (Dari)"
                valueType="format"
                :format="'DD/MM/YYYY'"
                v-model="filterStartDate"
              ></date-picker>
            </v-col>
            <v-col md="3">
              <date-picker
                placeholder="Tanggal Restock (Sampai)"
                valueType="format"
                :format="'DD/MM/YYYY'"
                v-model="filterEndDate"
              ></date-picker>
            </v-col>
          </template>
      </datatable>
      </div>
    </div>
    <form-action ref="form" module="merchandise-in-log" :success="formSuccess" />
    <delete-dialog
      ref="delete"
      url="merchandise-in-log"
      :success="deleteSuccess"
    ></delete-dialog>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Datatable from "@/view/component/Datatable.vue";
import DeleteDialog from "@/view/component/DeleteDialog.vue";
import FormAction from "./Form";
import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import Moment from "moment";

export default {
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Stock Merchandise", route: "" },
      { title: "Merchandise Restock" }
    ]);

    this.filterBy();
    const merchandises = await ApiService.get("merchandise/list");
    this.listMerchandise = merchandises.data;
  },
  data() {
    return {
      title: "Merchandise",
      url: "merchandise-in-log/data",
      filterMerchandise: null,
      filterStartDate: null,
      filterEndDate: null,
      listMerchandise: [],
      filter: null,
      columns: [
        {
          value: "id"
        },
         {
          text: "Merchandise",
          value: "merchandise_name",
          sortable: true,
          searchable: true
        },
        {
          text: "Tanggal Restock",
          value: "restock_date",
          sortable: true,
          searchable: false
        },
        {
          text: "Keterangan",
          value: "description",
          sortable: true,
          searchable: true
        },

        {
          text: "Jumlah",
          value: "amount",
          sortable: true,
          searchable: false
        },
        {
          text: "Updated At",
          value: "updated_at",
          sortable: true,
          searchable: false
        },
      ]
    };
  },
  methods: {
    onClickCreate() {
      this.$refs.form.open();
    },
    onClickUpdate(item) {
      this.$refs.form.open(item.id);
    },
    onClickDelete(item) {
      this.$refs.delete.open(item.id);
    },
    formSuccess() {
      this.$refs.datatable.getData();
    },
    deleteSuccess() {
      this.$refs.datatable.getData();
    },
    filterBy() {
      let finalFilter = [];

      if (this.filterMerchandise) {
        finalFilter = [
          ...finalFilter,
          {
            column: "merchandise_id",
            value: this.filterMerchandise,
          },
        ];
      }
      if (this.filterStartDate) {
        finalFilter = [
          ...finalFilter,
          {
            column: "restock_date",
            value: Moment(this.filterStartDate, "DD/MM/YYYY").format("YYYY-MM-DD"),
            operator: "gte",
          },
        ];
      }
      
      if (this.filterEndDate) {
        finalFilter = [
          ...finalFilter,
          {
            column: "restock_date",
            value: Moment(this.filterEndDate, "DD/MM/YYYY").format("YYYY-MM-DD"),
            operator: "lte",
          },
        ];
      }

      if (finalFilter.length > 0) {
        this.filter = finalFilter;
      } else {
        this.filter = null;
        this.filterSlug = null;
      }

       this.$refs.datatable.getData();
    },
    async onClickExport() {
      try {
        if (JwtService.getToken()) {
          const token = JwtService.getToken();
          var url =
            process.env.VUE_APP_SERVER_URL +
            "/merchandise-in-log/export?token=" +
            token +
            "";
          // if (this.selectedMonth) {
          //   url = url + "&month=" + this.selectedMonth;
          // }
          window.open(url, "_blank");
        }
      } catch (e) {
        this.$swal.fire({
          icon: "error",
          title: "Gagal",
          text: "Gagal mengunduh report.",
        });
      }
    },
  },
  watch: {
    filterMerchandise(v) {
      if (v) {
        this.filterMerchandise = v;
      } else {
        this.filterMerchandise = null;
      }

      this.filterBy();
    },
    filterStartDate(v) {
      if (v) {
        this.filterStartDate = v;
      } else {
        this.filterStartDate = null;
      }
      this.filterBy();
    },
    filterEndDate(v) {
      if (v) {
        this.filterEndDate = v;
      } else {
        this.filterEndDate = null;
      }
      this.filterBy();
    },
  },
  components: {
    Datatable,
    DeleteDialog,
    FormAction
  }
};
</script>
